'use client'

import s from '../style.module.scss'
import clsx from 'clsx'
import ThumbIcon from './thumb-icon'

type Props = {
  handleLike: () => void
  isLiked: boolean | undefined
  count: string
}

const LikeBtn = ({handleLike, isLiked, count}: Props) => {
  return (
    <button onClick={handleLike} className={s.buttons_text_wrapper}>
      <ThumbIcon
        className={clsx(s.icon, {
          [s.rotate_180]: !isLiked,
          [s.like_animation]: isLiked,
        })}
        filled={!!isLiked}
      />
      <p
        className={clsx(s.text, {
          [s.text_filled]: isLiked,
        })}
      >
        {count}
      </p>
    </button>
  )
}

export default LikeBtn
